import { render, staticRenderFns } from "./PropertyPinTagsForm.vue?vue&type=template&id=2a2d2652&"
import script from "./PropertyPinTagsForm.vue?vue&type=script&lang=js&"
export * from "./PropertyPinTagsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports